/*!
 * @modus/ionic-vue v3.0.0-alpha.17
 * 2020 Michael Tintiuc - Modus Create
 * @license MIT
 */

import { addIcons } from 'ionicons';
import { arrowBackSharp, caretBackSharp, chevronBack, chevronForward, close, closeCircle, closeSharp, menuOutline, menuSharp, reorderTwoSharp, reorderThreeOutline, searchOutline, searchSharp } from 'ionicons/icons';
import { setupConfig, modalController, actionSheetController, popoverController, isPlatform } from '@ionic/core';
import { defineCustomElements, applyPolyfills } from '@ionic/core/loader';
import { ref, defineComponent, h, shallowRef, Transition, nextTick, getCurrentInstance, onActivated } from 'vue';
import { useRouter, useLink, createRouter as createRouter$1, RouterView, useRoute } from 'vue-router';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var IonicVue = {
    isReady: function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, applyPolyfills()];
                    case 1:
                        _b.sent();
                        _a = window;
                        if (!_a) return [3 /*break*/, 3];
                        return [4 /*yield*/, defineCustomElements(window)];
                    case 2:
                        _a = (_b.sent());
                        _b.label = 3;
                    case 3:
                        return [2 /*return*/];
                }
            });
        });
    },
    install: function (_app, config) {
        console.info("[ionic/vue] BREAKING CHANGE, call to isReady is required before mounting the app:\nconst app = createApp(App).use(IonicVue, { mode: 'ios' });\nIonicVue.isReady().then(() => {\n  app.mount(\"#app\");\n});");
        config && setupConfig(config);
    }
};

var OverlayEvents;
(function (OverlayEvents) {
    OverlayEvents["onWillPresent"] = "onWillPresent";
    OverlayEvents["onDidPresent"] = "onDidPresent";
    OverlayEvents["onWillDismiss"] = "onWillDismiss";
    OverlayEvents["onDidDismiss"] = "onDidDismiss";
    OverlayEvents["onUpdate"] = "update:modelValue";
})(OverlayEvents || (OverlayEvents = {}));
var OverlayType;
(function (OverlayType) {
    OverlayType["Modal"] = "IonModal";
    OverlayType["ActionSheet"] = "IonActionSheet";
    OverlayType["Popover"] = "IonPopover";
})(OverlayType || (OverlayType = {}));
function defineOverlay(name, controller, componentProps) {
    var _a;
    var overlay = ref();
    var content = ref();
    var coreTag = name.charAt(0).toLowerCase() + name.slice(1);
    var eventListeners = Object.entries((_a = {},
        _a[coreTag + "WillPresent"] = OverlayEvents.onWillPresent,
        _a[coreTag + "DidPresent"] = OverlayEvents.onDidPresent,
        _a[coreTag + "WillDismiss"] = OverlayEvents.onWillDismiss,
        _a[coreTag + "DidDismiss"] = OverlayEvents.onDidDismiss,
        _a));
    var Overlay = defineComponent(function (props, _a) {
        var attrs = _a.attrs, slots = _a.slots, emit = _a.emit;
        return function () { return h('div', {
            style: { display: 'none' },
            onVnodeUpdated: function () {
                var _a, _b, _c;
                return __awaiter(this, void 0, void 0, function () {
                    var isOpen;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                isOpen = (_a = props.isOpen) !== null && _a !== void 0 ? _a : props.modelValue;
                                if (!isOpen) return [3 /*break*/, 2];
                                return [4 /*yield*/, (((_b = overlay.value) === null || _b === void 0 ? void 0 : _b.present()) || present(props, attrs, emit))];
                            case 1:
                                _d.sent();
                                return [3 /*break*/, 4];
                            case 2: return [4 /*yield*/, ((_c = overlay.value) === null || _c === void 0 ? void 0 : _c.dismiss())];
                            case 3:
                                _d.sent();
                                overlay.value = undefined;
                                _d.label = 4;
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            },
            onVnodeMounted: function () {
                var _a;
                return __awaiter(this, void 0, void 0, function () {
                    var isOpen, _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                isOpen = (_a = props.isOpen) !== null && _a !== void 0 ? _a : props.modelValue;
                                _b = isOpen;
                                if (!_b) return [3 /*break*/, 2];
                                return [4 /*yield*/, present(props, attrs, emit)];
                            case 1:
                                _b = (_c.sent());
                                _c.label = 2;
                            case 2:
                                return [2 /*return*/];
                        }
                    });
                });
            },
            onVnodeBeforeUnmount: function () {
                var _a;
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, ((_a = overlay.value) === null || _a === void 0 ? void 0 : _a.dismiss())];
                            case 1:
                                _b.sent();
                                overlay.value = undefined;
                                content.value = undefined;
                                return [2 /*return*/];
                        }
                    });
                });
            }
        }, [h('div', { ref: content }, slots)]); };
    });
    Overlay.displayName = name;
    Overlay.inheritAttrs = false;
    Overlay.props = __spreadArrays(['isOpen', 'modelValue'], componentProps);
    Overlay.emits = [
        OverlayEvents.onUpdate,
        OverlayEvents.onWillPresent,
        OverlayEvents.onDidPresent,
        OverlayEvents.onWillDismiss,
        OverlayEvents.onDidDismiss
    ];
    function present(props, _a, emit) {
        var _b, _c, _d, _e;
        var onWillPresent = _a.onWillPresent, onDidPresent = _a.onDidPresent, onWillDismiss = _a.onWillDismiss, onDidDismiss = _a.onDidDismiss;
        return __awaiter(this, void 0, void 0, function () {
            var _f, listeners, _loop_1, _i, eventListeners_1, _g, eventName, listener;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        _f = overlay;
                        return [4 /*yield*/, controller.create(__assign(__assign({}, props), { component: content.value }))];
                    case 1:
                        _f.value = _h.sent();
                        listeners = {
                            onWillPresent: onWillPresent,
                            onDidPresent: onDidPresent,
                            onWillDismiss: onWillDismiss,
                            onDidDismiss: onDidDismiss
                        };
                        _loop_1 = function (eventName, listener) {
                            var handlers = listeners[listener];
                            if (handlers) {
                                (_b = overlay.value) === null || _b === void 0 ? void 0 : _b.addEventListener(eventName, function (e) {
                                    Array.isArray(handlers) ? handlers.map(function (f) { return f(e); }) : handlers(e);
                                });
                            }
                            if (listener === OverlayEvents.onDidPresent) {
                                (_c = overlay.value) === null || _c === void 0 ? void 0 : _c.addEventListener(eventName, function () {
                                    emit(OverlayEvents.onUpdate, true);
                                });
                            }
                            else if (listener === OverlayEvents.onDidDismiss) {
                                (_d = overlay.value) === null || _d === void 0 ? void 0 : _d.addEventListener(eventName, function () {
                                    emit(OverlayEvents.onUpdate, false);
                                });
                            }
                        };
                        for (_i = 0, eventListeners_1 = eventListeners; _i < eventListeners_1.length; _i++) {
                            _g = eventListeners_1[_i], eventName = _g[0], listener = _g[1];
                            _loop_1(eventName, listener);
                        }
                        return [4 /*yield*/, ((_e = overlay.value) === null || _e === void 0 ? void 0 : _e.present())];
                    case 2:
                        _h.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    return Overlay;
}

var getComponentClasses = function (classes) {
    var _a;
    return ((_a = classes) === null || _a === void 0 ? void 0 : _a.split(' ')) || [];
};
var getElementClasses = function (ref, componentClasses, defaultClasses) {
    var _a;
    if (defaultClasses === void 0) { defaultClasses = []; }
    return __spreadArrays(Array.from(((_a = ref.value) === null || _a === void 0 ? void 0 : _a.classList) || []), defaultClasses).filter(function (c, i, self) { return !componentClasses.includes(c) && self.indexOf(c) === i; });
};
var splitPropsAndEvents = function (propsAndEvents) {
    var props = [];
    var events = [];
    var ignoredProps = ['component', 'componentProps', 'delegate'];
    propsAndEvents.map(function (i) { return (i.startsWith('on') ? events : props).push(i); });
    return { props: props.filter(function (p) { return !ignoredProps.includes(p); }), events: events };
};

var InputEvents;
(function (InputEvents) {
    InputEvents["onUpdate"] = "update:modelValue";
})(InputEvents || (InputEvents = {}));
// @TODO
// remove replace() when Vue supports camelCase events that Ionic uses
function defineInput(name, displayName, componentPropsAndEvents, updateEvent, modelProp) {
    if (updateEvent === void 0) { updateEvent = 'onIonChange'; }
    if (modelProp === void 0) { modelProp = 'value'; }
    var Input = defineComponent(function (props, _a) {
        var _b;
        var attrs = _a.attrs, slots = _a.slots, emit = _a.emit;
        var inputRef = ref();
        var classes = ((_b = attrs.class) === null || _b === void 0 ? void 0 : _b.split(' ')) || [];
        // @TODO hack to support CamelCase Ionic events
        var onVnodeBeforeMount = function (vnode) {
            if (vnode.el) {
                vnode.el.addEventListener(updateEvent.replace('onIon', 'ion'), function (e) {
                    emit(InputEvents.onUpdate, (e === null || e === void 0 ? void 0 : e.target)[modelProp]);
                });
                for (var _i = 0, _a = Object.entries(attrs); _i < _a.length; _i++) {
                    var _b = _a[_i], key = _b[0], event_1 = _b[1];
                    if (key.startsWith('onIon')) {
                        vnode.el.addEventListener(key.replace('onIon', 'ion'), event_1);
                    }
                }
            }
        };
        return function () {
            var _a;
            return h(name, __assign(__assign({}, props), (_a = { onVnodeBeforeMount: onVnodeBeforeMount, class: getElementClasses(inputRef, classes) }, _a[modelProp] = props.hasOwnProperty('modelValue') ? props.modelValue : props[modelProp], _a)), slots);
        };
    });
    var data = splitPropsAndEvents(componentPropsAndEvents);
    Input.displayName = displayName;
    Input.props = __spreadArrays([modelProp, 'modelValue'], data.props);
    Input.emits = __spreadArrays([InputEvents.onUpdate], data.events);
    return Input;
}

var defineContainer = function (name, displayName, componentProps) {
    var Container = defineComponent(function (props, _a) {
        var _b;
        var attrs = _a.attrs, slots = _a.slots;
        var containerRef = ref();
        var classes = ((_b = attrs.class) === null || _b === void 0 ? void 0 : _b.split(' ')) || [];
        return function () {
            return h(name, __assign(__assign({}, props), { ref: containerRef, class: getElementClasses(containerRef, classes) }), slots);
        };
    });
    Container.displayName = displayName;
    Container.props = componentProps;
    return Container;
};
var defineNavigableContainer = function (name, displayName, componentPropsAndEvents) {
    var Container = defineComponent(function (props, _a) {
        var _b;
        var attrs = _a.attrs, slots = _a.slots;
        var classes = ((_b = attrs.class) === null || _b === void 0 ? void 0 : _b.split(' ')) || [];
        var containerRef = ref();
        var router = useRouter();
        var href = props.href;
        var onClick;
        if (router && href !== undefined) {
            var link_1 = useLink({ to: href, replace: props.replace });
            href = link_1.href.value;
            onClick = function (e) {
                attrs.onClick && attrs.onClick(e);
                if (e.defaultPrevented || (props.target && /\b_blank\b/i.test(props.target))) {
                    return;
                }
                router.directionOverride = props.routerDirection;
                router.animationOverride = props.routerAnimation;
                link_1.navigate(e);
                e.preventDefault();
            };
        }
        return function () {
            return h(name, __assign(__assign({}, props), { href: href, onClick: onClick, ref: containerRef, class: getElementClasses(containerRef, classes) }), slots);
        };
    });
    var data = splitPropsAndEvents(componentPropsAndEvents);
    Container.displayName = displayName;
    Container.props = __spreadArrays(data.props, ['replace']);
    Container.emits = __spreadArrays(data.events, ['onClick']);
    return Container;
};

var IonModal = /*@__PURE__*/ defineOverlay(OverlayType.Modal, modalController, ["presentingElement", "showBackdrop", "backdropDismiss", "cssClass", "animated", "swipeToClose", "mode", "keyboardClose", "id", "enterAnimation", "leaveAnimation"]);
var IonActionSheet = /*@__PURE__*/ defineOverlay(OverlayType.ActionSheet, actionSheetController, ["header", "subHeader", "cssClass", "buttons", "backdropDismiss", "translucent", "animated", "mode", "keyboardClose", "id", "enterAnimation", "leaveAnimation"]);
var IonPopover = /*@__PURE__*/ defineOverlay(OverlayType.Popover, popoverController, ["showBackdrop", "backdropDismiss", "cssClass", "animated", "mode", "keyboardClose", "id", "enterAnimation", "leaveAnimation", "translucent", "event"]);

var IonCheckbox = /*@__PURE__*/ defineInput('ion-checkbox', 'IonCheckbox', ["checked", "color", "disabled", "indeterminate", "mode", "name", "onIonBlur", "onIonChange", "onIonFocus", "value"], 'onIonChange', 'checked');
var IonDatetime = /*@__PURE__*/ defineInput('ion-datetime', 'IonDatetime', ["cancelText", "dayNames", "dayShortNames", "dayValues", "disabled", "displayFormat", "displayTimezone", "doneText", "hourValues", "max", "min", "minuteValues", "mode", "monthNames", "monthShortNames", "monthValues", "name", "onIonBlur", "onIonCancel", "onIonChange", "onIonFocus", "pickerFormat", "pickerOptions", "placeholder", "readonly", "value", "yearValues"]);
var IonInput = /*@__PURE__*/ defineInput('ion-input', 'IonInput', ["accept", "autocapitalize", "autocomplete", "autocorrect", "autofocus", "clearInput", "clearOnEdit", "color", "debounce", "disabled", "enterkeyhint", "inputmode", "max", "maxlength", "min", "minlength", "mode", "multiple", "name", "onIonBlur", "onIonChange", "onIonFocus", "onIonInput", "pattern", "placeholder", "readonly", "required", "size", "spellcheck", "step", "type", "value"], 'onIonInput');
var IonRadio = /*@__PURE__*/ defineInput('ion-radio', 'IonRadio', ["color", "disabled", "mode", "name", "onIonBlur", "onIonFocus", "value"], 'onIonSelect');
var IonRadioGroup = /*@__PURE__*/ defineInput('ion-radio-group', 'IonRadioGroup', ["allowEmptySelection", "name", "onIonChange", "value"], 'onIonChange');
var IonRange = /*@__PURE__*/ defineInput('ion-range', 'IonRange', ["color", "debounce", "disabled", "dualKnobs", "max", "min", "mode", "name", "onIonBlur", "onIonChange", "onIonFocus", "pin", "snaps", "step", "ticks", "value"]);
var IonSearchbar = /*@__PURE__*/ defineInput('ion-searchbar', 'IonSearchbar', ["animated", "autocomplete", "autocorrect", "cancelButtonIcon", "cancelButtonText", "clearIcon", "color", "debounce", "disabled", "enterkeyhint", "inputmode", "mode", "onIonBlur", "onIonCancel", "onIonChange", "onIonClear", "onIonFocus", "onIonInput", "placeholder", "searchIcon", "showCancelButton", "spellcheck", "type", "value"], 'onIonInput');
var IonSelect = /*@__PURE__*/ defineInput('ion-select', 'IonSelect', ["cancelText", "compareWith", "disabled", "interface", "interfaceOptions", "mode", "multiple", "name", "okText", "onIonBlur", "onIonCancel", "onIonChange", "onIonFocus", "placeholder", "selectedText", "value"]);
var IonTextarea = /*@__PURE__*/ defineInput('ion-textarea', 'IonTextarea', ["autoGrow", "autocapitalize", "autofocus", "clearOnEdit", "color", "cols", "debounce", "disabled", "enterkeyhint", "inputmode", "maxlength", "minlength", "mode", "name", "onIonBlur", "onIonChange", "onIonFocus", "onIonInput", "placeholder", "readonly", "required", "rows", "spellcheck", "value", "wrap"]);
var IonToggle = /*@__PURE__*/ defineInput('ion-toggle', 'IonToggle', ["checked", "color", "disabled", "mode", "name", "onIonBlur", "onIonChange", "onIonFocus", "value"], 'onIonChange', 'checked');

var IonApp = /*@__PURE__*/ defineContainer('ion-app', 'IonApp', []);
var IonAvatar = /*@__PURE__*/ defineContainer('ion-avatar', 'IonAvatar', []);
var IonBackdrop = /*@__PURE__*/ defineContainer('ion-backdrop', 'IonBackdrop', ["onIonBackdropTap", "stopPropagation", "tappable", "visible"]);
var IonBadge = /*@__PURE__*/ defineContainer('ion-badge', 'IonBadge', ["color", "mode"]);
var IonButton = /*@__PURE__*/ defineNavigableContainer('ion-button', 'IonButton', ["buttonType", "color", "disabled", "download", "expand", "fill", "href", "mode", "onIonBlur", "onIonFocus", "rel", "routerAnimation", "routerDirection", "shape", "size", "strong", "target", "type"]);
var IonButtons = /*@__PURE__*/ defineContainer('ion-buttons', 'IonButtons', ["collapse"]);
var IonCard = /*@__PURE__*/ defineNavigableContainer('ion-card', 'IonCard', ["button", "color", "disabled", "download", "href", "mode", "rel", "routerAnimation", "routerDirection", "target", "type"]);
var IonCardContent = /*@__PURE__*/ defineContainer('ion-card-content', 'IonCardContent', ["mode"]);
var IonCardHeader = /*@__PURE__*/ defineContainer('ion-card-header', 'IonCardHeader', ["color", "mode", "translucent"]);
var IonCardSubtitle = /*@__PURE__*/ defineContainer('ion-card-subtitle', 'IonCardSubtitle', ["color", "mode"]);
var IonCardTitle = /*@__PURE__*/ defineContainer('ion-card-title', 'IonCardTitle', ["color", "mode"]);
var IonChip = /*@__PURE__*/ defineContainer('ion-chip', 'IonChip', ["color", "mode", "outline"]);
var IonCol = /*@__PURE__*/ defineContainer('ion-col', 'IonCol', ["offset", "offsetLg", "offsetMd", "offsetSm", "offsetXl", "offsetXs", "pull", "pullLg", "pullMd", "pullSm", "pullXl", "pullXs", "push", "pushLg", "pushMd", "pushSm", "pushXl", "pushXs", "size", "sizeLg", "sizeMd", "sizeSm", "sizeXl", "sizeXs"]);
var IonContent = /*@__PURE__*/ defineContainer('ion-content', 'IonContent', ["color", "forceOverscroll", "fullscreen", "onIonScroll", "onIonScrollEnd", "onIonScrollStart", "scrollEvents", "scrollX", "scrollY"]);
var IonFab = /*@__PURE__*/ defineContainer('ion-fab', 'IonFab', ["activated", "edge", "horizontal", "vertical"]);
var IonFabButton = /*@__PURE__*/ defineNavigableContainer('ion-fab-button', 'IonFabButton', ["activated", "closeIcon", "color", "disabled", "download", "href", "mode", "onIonBlur", "onIonFocus", "rel", "routerAnimation", "routerDirection", "show", "size", "target", "translucent", "type"]);
var IonFabList = /*@__PURE__*/ defineContainer('ion-fab-list', 'IonFabList', ["activated", "side"]);
var IonFooter = /*@__PURE__*/ defineContainer('ion-footer', 'IonFooter', ["mode", "translucent"]);
var IonGrid = /*@__PURE__*/ defineContainer('ion-grid', 'IonGrid', ["fixed"]);
var IonHeader = /*@__PURE__*/ defineContainer('ion-header', 'IonHeader', ["collapse", "mode", "translucent"]);
var IonImg = /*@__PURE__*/ defineContainer('ion-img', 'IonImg', ["alt", "onIonError", "onIonImgDidLoad", "onIonImgWillLoad", "src"]);
var IonInfiniteScroll = /*@__PURE__*/ defineContainer('ion-infinite-scroll', 'IonInfiniteScroll', ["disabled", "onIonInfinite", "position", "threshold"]);
var IonInfiniteScrollContent = /*@__PURE__*/ defineContainer('ion-infinite-scroll-content', 'IonInfiniteScrollContent', ["loadingSpinner", "loadingText"]);
var IonItem = /*@__PURE__*/ defineNavigableContainer('ion-item', 'IonItem', ["button", "color", "detail", "detailIcon", "disabled", "download", "href", "lines", "mode", "rel", "routerAnimation", "routerDirection", "target", "type"]);
var IonItemDivider = /*@__PURE__*/ defineContainer('ion-item-divider', 'IonItemDivider', ["color", "mode", "sticky"]);
var IonItemGroup = /*@__PURE__*/ defineContainer('ion-item-group', 'IonItemGroup', []);
var IonItemOption = /*@__PURE__*/ defineNavigableContainer('ion-item-option', 'IonItemOption', ["color", "disabled", "download", "expandable", "href", "mode", "rel", "target", "type"]);
var IonItemOptions = /*@__PURE__*/ defineContainer('ion-item-options', 'IonItemOptions', ["onIonSwipe", "side"]);
var IonItemSliding = /*@__PURE__*/ defineContainer('ion-item-sliding', 'IonItemSliding', ["disabled", "onIonDrag"]);
var IonLabel = /*@__PURE__*/ defineContainer('ion-label', 'IonLabel', ["color", "mode", "position"]);
var IonList = /*@__PURE__*/ defineContainer('ion-list', 'IonList', ["inset", "lines", "mode"]);
var IonListHeader = /*@__PURE__*/ defineContainer('ion-list-header', 'IonListHeader', ["color", "lines", "mode"]);
var IonMenu = /*@__PURE__*/ defineContainer('ion-menu', 'IonMenu', ["contentId", "disabled", "maxEdgeStart", "menuId", "onIonDidClose", "onIonDidOpen", "onIonWillClose", "onIonWillOpen", "side", "swipeGesture", "type"]);
var IonMenuButton = /*@__PURE__*/ defineContainer('ion-menu-button', 'IonMenuButton', ["autoHide", "color", "disabled", "menu", "mode", "type"]);
var IonMenuToggle = /*@__PURE__*/ defineContainer('ion-menu-toggle', 'IonMenuToggle', ["autoHide", "menu"]);
var IonNote = /*@__PURE__*/ defineContainer('ion-note', 'IonNote', ["color", "mode"]);
var IonPickerColumn = /*@__PURE__*/ defineContainer('ion-picker-column', 'IonPickerColumn', ["col"]);
var IonProgressBar = /*@__PURE__*/ defineContainer('ion-progress-bar', 'IonProgressBar', ["buffer", "color", "mode", "reversed", "type", "value"]);
var IonRefresher = /*@__PURE__*/ defineContainer('ion-refresher', 'IonRefresher', ["closeDuration", "disabled", "onIonPull", "onIonRefresh", "onIonStart", "pullFactor", "pullMax", "pullMin", "snapbackDuration"]);
var IonRefresherContent = /*@__PURE__*/ defineContainer('ion-refresher-content', 'IonRefresherContent', ["pullingIcon", "pullingText", "refreshingSpinner", "refreshingText"]);
var IonReorder = /*@__PURE__*/ defineContainer('ion-reorder', 'IonReorder', []);
var IonReorderGroup = /*@__PURE__*/ defineContainer('ion-reorder-group', 'IonReorderGroup', ["disabled", "onIonItemReorder"]);
var IonRippleEffect = /*@__PURE__*/ defineContainer('ion-ripple-effect', 'IonRippleEffect', ["type"]);
var IonRouterLink = /*@__PURE__*/ defineNavigableContainer('ion-router-link', 'IonRouterLink', ["color", "href", "rel", "routerAnimation", "routerDirection", "target"]);
var IonRow = /*@__PURE__*/ defineContainer('ion-row', 'IonRow', []);
var IonSegment = /*@__PURE__*/ defineContainer('ion-segment', 'IonSegment', ["color", "disabled", "mode", "onIonChange", "scrollable", "value"]);
var IonSegmentButton = /*@__PURE__*/ defineContainer('ion-segment-button', 'IonSegmentButton', ["disabled", "layout", "mode", "type", "value"]);
var IonSelectOption = /*@__PURE__*/ defineContainer('ion-select-option', 'IonSelectOption', ["disabled", "value"]);
var IonSelectPopover = /*@__PURE__*/ defineContainer('ion-select-popover', 'IonSelectPopover', ["header", "message", "options", "subHeader"]);
var IonSkeletonText = /*@__PURE__*/ defineContainer('ion-skeleton-text', 'IonSkeletonText', ["animated"]);
var IonSlide = /*@__PURE__*/ defineContainer('ion-slide', 'IonSlide', []);
var IonSlides = /*@__PURE__*/ defineContainer('ion-slides', 'IonSlides', ["mode", "onIonSlideDidChange", "onIonSlideDoubleTap", "onIonSlideDrag", "onIonSlideNextEnd", "onIonSlideNextStart", "onIonSlidePrevEnd", "onIonSlidePrevStart", "onIonSlideReachEnd", "onIonSlideReachStart", "onIonSlideTap", "onIonSlideTouchEnd", "onIonSlideTouchStart", "onIonSlideTransitionEnd", "onIonSlideTransitionStart", "onIonSlideWillChange", "onIonSlidesDidLoad", "options", "pager", "scrollbar"]);
var IonSpinner = /*@__PURE__*/ defineContainer('ion-spinner', 'IonSpinner', ["color", "duration", "name", "paused"]);
var IonSplitPane = /*@__PURE__*/ defineContainer('ion-split-pane', 'IonSplitPane', ["contentId", "disabled", "onIonSplitPaneVisible", "when"]);
var IonText = /*@__PURE__*/ defineContainer('ion-text', 'IonText', ["color", "mode"]);
var IonThumbnail = /*@__PURE__*/ defineContainer('ion-thumbnail', 'IonThumbnail', []);
var IonTitle = /*@__PURE__*/ defineContainer('ion-title', 'IonTitle', ["color", "size"]);
var IonToolbar = /*@__PURE__*/ defineContainer('ion-toolbar', 'IonToolbar', ["color", "mode"]);
var IonVirtualScroll = /*@__PURE__*/ defineContainer('ion-virtual-scroll', 'IonVirtualScroll', ["approxFooterHeight", "approxHeaderHeight", "approxItemHeight", "footerFn", "footerHeight", "headerFn", "headerHeight", "itemHeight", "items", "nodeRender", "renderFooter", "renderHeader", "renderItem"]);

var createRouter = function (opts) {
    var direction = ref('forward');
    var animationOverride = ref();
    var directionOverride = ref();
    var showBackButton = ref(false);
    var scroll = new Map();
    var router = __assign(__assign({}, createRouter$1(opts)), { history: opts.history, saveScroll: function (el, key) {
            return __awaiter(this, void 0, void 0, function () {
                var ionContent, scrollElement, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            ionContent = el.querySelector('ion-content');
                            _a = ionContent;
                            if (!_a) return [3 /*break*/, 2];
                            return [4 /*yield*/, ionContent.getScrollElement()];
                        case 1:
                            _a = (_b.sent());
                            _b.label = 2;
                        case 2:
                            scrollElement = _a;
                            if (scrollElement && key) {
                                scroll.set(key, {
                                    top: (scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.scrollTop) || 0,
                                    left: (scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.scrollLeft) || 0,
                                });
                            }
                            return [2 /*return*/];
                    }
                });
            });
        },
        restoreScroll: function (el, key) {
            return __awaiter(this, void 0, void 0, function () {
                var ionContent, scrollElement, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            ionContent = el.querySelector('ion-content');
                            _a = ionContent;
                            if (!_a) return [3 /*break*/, 2];
                            return [4 /*yield*/, ionContent.getScrollElement()];
                        case 1:
                            _a = (_b.sent());
                            _b.label = 2;
                        case 2:
                            scrollElement = (_a) || undefined;
                            scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.scrollTo(scroll.get(key) || {
                                top: 0,
                                left: 0,
                            });
                            return [2 /*return*/];
                    }
                });
            });
        } });
    router.history.listen(function (_to, _from, info) {
        directionOverride.value = info.direction;
    });
    router.beforeEach(function (to, from, next) {
        showBackButton.value = to.fullPath !== '/' || !!router.history.state.back;
        direction.value =
            directionOverride.value ||
                (to.fullPath.startsWith(from.fullPath) ? 'forward' : 'back');
        directionOverride.value = undefined;
        next();
    });
    router.afterEach(function (to) {
        showBackButton.value = to.fullPath !== '/' || !!router.history.state.back;
        animationOverride.value = undefined;
    });
    Object.defineProperties(router, {
        direction: {
            get: function () {
                return directionOverride.value || direction.value;
            },
        },
        showBackButton: {
            get: function () {
                return showBackButton.value;
            }
        },
        directionOverride: {
            get: function () {
                return directionOverride.value;
            },
            set: function (value) {
                directionOverride.value = value;
            }
        },
        animationOverride: {
            get: function () {
                return animationOverride.value;
            },
            set: function (value) {
                animationOverride.value = value;
            }
        }
    });
    if (document) {
        document.addEventListener('ionBackButton', function (e) {
            e.detail.register(0, function (next) {
                router.history.go(-1);
                next();
            });
        });
    }
    return router;
};

var IonRouterView = defineComponent(function (props, _a) {
    var slots = _a.slots;
    var router = useRouter();
    var ionRouterOutlet = ref();
    var enteringEl = ref();
    var newView = shallowRef();
    var persisted = false;
    var progressAnimation = false;
    var inTransition = false;
    var transition = function (leavingEl) { return __awaiter(void 0, void 0, void 0, function () {
        var outlet;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!enteringEl.value || enteringEl.value === leavingEl) {
                        return [2 /*return*/];
                    }
                    // ion-page class makes ion-split-pane invisible
                    if (enteringEl.value.nodeName !== 'ION-SPLIT-PANE') {
                        enteringEl.value.classList.add('ion-page', 'ion-page-invisible');
                    }
                    enteringEl.value.style.display = '';
                    return [4 /*yield*/, ((_a = ionRouterOutlet.value) === null || _a === void 0 ? void 0 : _a.componentOnReady())];
                case 1:
                    outlet = _b.sent();
                    return [2 /*return*/, outlet === null || outlet === void 0 ? void 0 : outlet.commit(enteringEl.value, leavingEl, {
                            deepWait: true,
                            direction: router.direction,
                            showGoBack: router.showBackButton,
                            duration: persisted ? 0 : undefined,
                            animationBuilder: router.animationOverride,
                            progressAnimation: progressAnimation,
                        })];
            }
        });
    }); };
    var transitionHooks = {
        onEnter: function (el, done) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            inTransition = true;
                            enteringEl.value = el;
                            if (!(router.direction === 'back')) return [3 /*break*/, 2];
                            return [4 /*yield*/, router.restoreScroll(el, progressAnimation
                                    ? router.history.state.back
                                    : router.currentRoute.value.fullPath)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            done();
                            return [2 /*return*/];
                    }
                });
            });
        },
        onLeave: function (el, done) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!persisted) return [3 /*break*/, 2];
                            return [4 /*yield*/, router.saveScroll(el, progressAnimation
                                    ? router.currentRoute.value.fullPath
                                    : router.history.state.back)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [4 /*yield*/, transition(el)];
                        case 3:
                            _a.sent();
                            persisted ? setTimeout(done, 100) : done();
                            inTransition = false;
                            persisted = false;
                            return [2 /*return*/];
                    }
                });
            });
        },
    };
    var routerView = h(RouterView, { name: props.name, route: props.route }, function () {
        var _a, _b;
        var opts = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            opts[_i] = arguments[_i];
        }
        var _c = opts[0], Component = _c.Component, matchedRoute = _c.route;
        var child = (_a = newView.value) !== null && _a !== void 0 ? _a : Component;
        if (((_b = newView.value) === null || _b === void 0 ? void 0 : _b.type) === (Component === null || Component === void 0 ? void 0 : Component.type)) {
            newView.value = undefined;
        }
        if (child === null || child === void 0 ? void 0 : child.props) {
            child.props.class = {
                'can-go-back': !!router.history.state.back,
            };
        }
        if (persisted && child) {
            nextTick(function () {
                var leaveCb = enteringEl.value._leaveCb;
                leaveCb && leaveCb();
            });
        }
        var transitionProps = __assign({ css: false, mode: 'in-out', persisted: persisted }, transitionHooks);
        return slots.default
            ? slots.default({ Component: child, route: matchedRoute, transitionProps: transitionProps })
            : h(Transition, transitionProps, function () { return child; });
    });
    return function () { return h('ion-router-outlet', __assign(__assign({}, props), { ref: ionRouterOutlet, 
        // workaround for Vue 3 camelCase prop issue
        onVnodeMounted: function (vnode) {
            (vnode === null || vnode === void 0 ? void 0 : vnode.el) &&
                (vnode.el.swipeHandler = {
                    canStart: function () {
                        var _a;
                        return (!inTransition &&
                            !!router.history.state.back &&
                            props.swipeBack !== false &&
                            ((_a = ionRouterOutlet.value) === null || _a === void 0 ? void 0 : _a.mode) === 'ios');
                    },
                    onStart: function () {
                        progressAnimation = true;
                        inTransition = true;
                        router.directionOverride = 'back';
                        var matchedRoutes = router.resolve(router.history.state.back);
                        if (matchedRoutes.matched.length) {
                            var matchedRoute = matchedRoutes.matched[0];
                            var routePropsOption = matchedRoute.props[props.name || 'default'];
                            var routeProps = routePropsOption
                                ? routePropsOption === true
                                    ? matchedRoutes.params
                                    : typeof routePropsOption === 'function'
                                        ? routePropsOption(matchedRoutes)
                                        : routePropsOption
                                : null;
                            newView.value = h(matchedRoute.components[props.name || 'default'], routeProps);
                        }
                    },
                    onEnd: function (shouldComplete) {
                        inTransition = false;
                        progressAnimation = false;
                        if (shouldComplete) {
                            nextTick(function () {
                                persisted = false;
                                router.go(-1);
                            });
                            return;
                        }
                        persisted = true;
                        newView.value = undefined;
                    },
                });
        } }), routerView); };
});
var data = splitPropsAndEvents(["animated", "animation", "mode"]);
IonRouterView.displayName = 'IonRouterView';
IonRouterView.props = __spreadArrays(data.props, ['name', 'route']);
IonRouterView.emits = data.events;

var IonBackButton = defineComponent(function (props, _a) {
    var attrs = _a.attrs;
    var router = useRouter();
    var buttonRef = ref();
    var classes = getComponentClasses(attrs.class);
    return function () { return h('ion-back-button', __assign(__assign({}, props), { ref: buttonRef, class: getElementClasses(buttonRef, classes), onClick: function (e) {
            attrs.onClick && attrs.onClick(e);
            if (e.defaultPrevented || !router) {
                return;
            }
            router.animationOverride = props.routerAnimation;
            props.defaultHref
                ? router.replace(props.defaultHref)
                : router.history.go(-1);
        } })); };
});
var data$1 = splitPropsAndEvents(["color", "defaultHref", "disabled", "icon", "mode", "routerAnimation", "text", "type"]);
IonBackButton.displayName = 'IonBackButton';
IonBackButton.props = data$1.props;
IonBackButton.emits = __spreadArrays(['onClick'], data$1.events);

// CSS for ion-tabs inner and outer elements
var hostStyles = {
    display: 'flex',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    contain: 'layout size style',
};
var innerStyles = {
    position: 'relative',
    flex: 1,
    contain: 'layout size style',
};
var tabsRef = ref();
var tabRefs = {};
var tabLocations = {};
var data$2 = splitPropsAndEvents(["onIonTabsDidChange", "onIonTabsWillChange"]);
var IonTabs = defineComponent(function (props, _a) {
    var slots = _a.slots, attrs = _a.attrs;
    // @TODO remove when Vue3 allows for camelCase props and events
    var onVnodeMounted = function (_a) {
        var el = _a.el;
        if (el) {
            el.onIonTabsDidChange = attrs.onIonTabsDidChange;
            el.onIonTabsWillChange = attrs.onIonTabsWillChange;
        }
    };
    return function () { return h('div', __assign(__assign({}, props), { onVnodeMounted: onVnodeMounted, style: hostStyles, ref: tabsRef }), [
        slots.top && slots.top(),
        h('div', { class: 'tabs-inner', style: innerStyles }, slots),
        slots.bottom && slots.bottom(),
    ]); };
});
IonTabs.displayName = 'IonTabs';
IonTabs.emits = data$2.events;

var tabBarRef = ref();
var setActiveTab = function (value) {
    Object.keys(tabRefs).forEach(function (tabName) {
        var _a;
        var tab = (_a = tabRefs[tabName]) === null || _a === void 0 ? void 0 : _a.value;
        tab && (tab.active = tabName === value);
    });
};
var IonTabBar = defineComponent(function (props, _a) {
    var _b;
    var slots = _a.slots;
    var tabs = Object.keys(tabRefs);
    var selectedTab = ((_b = tabBarRef.value) === null || _b === void 0 ? void 0 : _b.selectedTab) || props.selectedTab || (tabs.length && tabs[0]) || undefined;
    return function () { return h('ion-tab-bar', __assign(__assign({}, props), { selectedTab: selectedTab, ref: tabBarRef }), slots); };
});
var data$3 = splitPropsAndEvents(["color", "mode", "selectedTab", "translucent"]);
IonTabBar.displayName = 'IonTabBar';
IonTabBar.props = data$3.props;
IonTabBar.emits = data$3.events;

var IonTab = defineComponent(function (props, _a) {
    var _b, _c;
    var slots = _a.slots;
    var tabNode = tabRefs[props.tab];
    var active = ((_b = tabBarRef.value) === null || _b === void 0 ? void 0 : _b.selectedTab) === props.tab;
    var instance = getCurrentInstance();
    var route = useRoute();
    if (((_c = tabBarRef.value) === null || _c === void 0 ? void 0 : _c.selectedTab) === undefined) {
        tabBarRef.value && (tabBarRef.value.selectedTab = props.tab);
        active = true;
    }
    if (!tabNode) {
        tabRefs[props.tab] = ref();
    }
    tabNode = tabRefs[props.tab];
    // Only add Lifecycle.ACTIVATE hooks once
    // @ts-ignore
    if (!(instance === null || instance === void 0 ? void 0 : instance.a) || (instance === null || instance === void 0 ? void 0 : instance.a.length) === 0) {
        onActivated(function () {
            var tabRef = tabRefs[props.tab].value;
            tabBarRef.value && (tabBarRef.value.selectedTab = props.tab);
            tabRef && (tabRef.active = true);
        }, instance);
    }
    var onVnodeUpdated = function () {
        var _a;
        if (((_a = tabBarRef.value) === null || _a === void 0 ? void 0 : _a.selectedTab) === props.tab) {
            route && (tabLocations[props.tab] = route.fullPath);
        }
    };
    var onVnodeBeforeUnmount = function () {
        tabBarRef.value && (tabBarRef.value.selectedTab = undefined);
    };
    return function () { return h('ion-tab', __assign(__assign({}, props), { active: active, onVnodeUpdated: onVnodeUpdated, onVnodeBeforeUnmount: onVnodeBeforeUnmount, ref: tabRefs[props.tab] }), slots); };
});
var data$4 = splitPropsAndEvents(["component", "tab"]);
IonTab.displayName = 'IonTab';
IonTab.props = data$4.props;
IonTab.emits = data$4.events;

var IonTabButton = defineComponent(function (props, _a) {
    var attrs = _a.attrs, slots = _a.slots;
    var router = useRouter();
    var onClick = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var wasActiveTab, location_1, goToRoot;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            attrs.onClick && attrs.onClick(e);
            if (e.defaultPrevented) {
                return [2 /*return*/];
            }
            if (tabsRef.value && tabsRef.value.onIonTabsWillChange && props.tab) {
                tabsRef.value.onIonTabsWillChange(new CustomEvent('ionTabWillChange', { detail: { tab: props.tab } }));
            }
            wasActiveTab = ((_a = tabBarRef.value) === null || _a === void 0 ? void 0 : _a.selectedTab) === props.tab;
            tabBarRef.value && (tabBarRef.value.selectedTab = props === null || props === void 0 ? void 0 : props.tab);
            if (props.tab && props.href && router) {
                location_1 = tabLocations[props.tab] || props.href;
                goToRoot = wasActiveTab && router.currentRoute.value.fullPath === location_1;
                setActiveTab((_b = tabBarRef.value) === null || _b === void 0 ? void 0 : _b.selectedTab);
                location_1 && router.push(goToRoot ? props.href : location_1);
            }
            else {
                setActiveTab((_c = tabBarRef.value) === null || _c === void 0 ? void 0 : _c.selectedTab);
            }
            if (tabsRef.value && tabsRef.value.onIonTabsDidChange && props.tab) {
                tabsRef.value.onIonTabsDidChange(new CustomEvent('ionTabDidChange', { detail: { tab: props.tab } }));
            }
            e.preventDefault();
            return [2 /*return*/];
        });
    }); };
    return function () { return h('ion-tab-button', __assign(__assign({}, props), { onClick: onClick }), slots); };
});
var data$5 = splitPropsAndEvents(["disabled", "download", "href", "layout", "mode", "rel", "selected", "tab", "target"]);
IonTabButton.displayName = 'IonTabButton';
IonTabButton.props = data$5.props;
IonTabButton.emits = __spreadArrays(['onClick'], data$5.events);

var IonIcon = defineComponent(function (props, _a) {
    var _b, _c, _d;
    var attrs = _a.attrs;
    var icon = (_d = (isPlatform(window, 'ios') ? (_b = props.ios) !== null && _b !== void 0 ? _b : props.md : (_c = props.md) !== null && _c !== void 0 ? _c : props.ios)) !== null && _d !== void 0 ? _d : props.icon;
    var iconRef = ref();
    var classes = getComponentClasses(attrs.class);
    return function () { return h('ion-icon', __assign(__assign({}, props), { icon: icon, ref: iconRef, class: getElementClasses(iconRef, classes) })); };
});
var data$6 = splitPropsAndEvents(["ariaLabel", "color", "flipRtl", "icon", "ios", "lazy", "md", "mode", "name", "size", "src"]);
IonIcon.displayName = 'IonIcon';
IonIcon.props = data$6.props;
IonIcon.emits = data$6.events;

var IonPage = defineComponent(function (props, _a) {
    var attrs = _a.attrs, slots = _a.slots;
    var pageRef = ref();
    var classes = getComponentClasses(attrs.class);
    return function () {
        return h('ion-page', __assign(__assign({}, props), { ref: pageRef, class: getElementClasses(pageRef, classes, ['ion-page']) }), slots);
    };
});
IonPage.displayName = 'IonPage';

// Icons that are used by internal components
addIcons({
    'arrow-back-sharp': arrowBackSharp,
    'caret-back-sharp': caretBackSharp,
    'chevron-back': chevronBack,
    'chevron-forward': chevronForward,
    close: close,
    'close-circle': closeCircle,
    'close-sharp': closeSharp,
    'menu-outline': menuOutline,
    'menu-sharp': menuSharp,
    'reorder-two-sharp': reorderTwoSharp,
    'reorder-three-outline': reorderThreeOutline,
    'search-outline': searchOutline,
    'search-sharp': searchSharp
});

export { IonActionSheet, IonApp, IonAvatar, IonBackButton, IonBackdrop, IonBadge, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCheckbox, IonChip, IonCol, IonContent, IonDatetime, IonFab, IonFabButton, IonFabList, IonFooter, IonGrid, IonHeader, IonIcon, IonImg, IonInfiniteScroll, IonInfiniteScrollContent, IonInput, IonItem, IonItemDivider, IonItemGroup, IonItemOption, IonItemOptions, IonItemSliding, IonLabel, IonList, IonListHeader, IonMenu, IonMenuButton, IonMenuToggle, IonModal, IonNote, IonPage, IonPickerColumn, IonPopover, IonProgressBar, IonRadio, IonRadioGroup, IonRange, IonRefresher, IonRefresherContent, IonReorder, IonReorderGroup, IonRippleEffect, IonRouterLink, IonRouterView, IonRow, IonSearchbar, IonSegment, IonSegmentButton, IonSelect, IonSelectOption, IonSelectPopover, IonSkeletonText, IonSlide, IonSlides, IonSpinner, IonSplitPane, IonTab, IonTabBar, IonTabButton, IonTabs, IonText, IonTextarea, IonThumbnail, IonTitle, IonToggle, IonToolbar, IonVirtualScroll, IonicVue, createRouter };
//# sourceMappingURL=ionic-vue.js.map
